import { render, staticRenderFns } from "./TabItem.vue?vue&type=template&id=3f9a5b22"
import script from "./TabItem.vue?vue&type=script&lang=js"
export * from "./TabItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports